export default "__VITE_ASSET__btcmzaw$__"